<template>
  <v-select
    class="search-select-item"
    v-model="filters.orientationsSelected"
    item-text="name"
    item-value="id"
    :menu-props="{contentClass:'multi-select-search-menu', maxHeight: 'calc(100vh - 24px)'}"
    :label="$t('ARTWORK.ORIENTATION')"
    :items="orientations"
    solo
    flat
    multiple
    hide-details
    clearable
    return-object
    @click:clear="$emit('search')"
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ $t('ARTWORK.ORIENTATION') }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: ["filters", "orientations", "loading"],

  watch: {
    "filters.orientationsSelected": {
      handler: function(val) {
        this.$emit("change");
      }
    }
  }
};
</script>
